<article class="section-inset-y block-cta" [class.is--dark]="block.hasDarkTheme">
  <div class="container container-size-md text-center text-md-start">
    <h1 class="fs-display-1 lh-09 mb-5" [class.text-light]="block.hasDarkTheme" *ngIf="block.title">
      <ngx-dynamic-hooks
        [options]="{ sanitize: false, updateOnPushOnly: true }"
        [content]="block.title | highlight : 'fw-bolder fst-italic text-uppercase' : false : true : 'squiggle-03' : 'secondary'"
        data-split
        [duration]="400"
        [context]="{ delayAnimation: 800, startShapeAnimation: inviewPort }"
        class="splitting splitting--word-in"
      ></ngx-dynamic-hooks>
    </h1>
    <fstr-link
      class="d-block anim-fade-up delay--2"
      *ngIf="block.button?.url || block.button?.routerLink"
      [button]="block.button!"
      [cssClasses]="'button button--primary-gradient has--dot'"
    ></fstr-link>
  </div>
</article>
